import React, { useState, useEffect } from 'react';
import { getDailySentence, refreshDailySentence } from './dailyEnglishService';
import languageManager from '../../../../utils/languageManager';
import './DailyEnglish.css';

const DailyEnglishContent = ({ app }) => {
  const [currentSentence, setCurrentSentence] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 获取每日英语句子
  useEffect(() => {
    loadDailySentence();
  }, []);

  const loadDailySentence = async () => {
    try {
      setLoading(true);
      setError(null);
      const sentence = await getDailySentence();
      setCurrentSentence(sentence);
    } catch (err) {
      console.error('获取每日英语句子失败:', err);
      setError(languageManager.t('common.loadFailed'));
    } finally {
      setLoading(false);
    }
  };

  // 刷新句子（手动刷新，强制更换数据）
  const handleRefresh = async () => {
    try {
      setLoading(true);
      setError(null);
      // 使用刷新函数，优先使用预加载缓存
      const sentence = await refreshDailySentence();
      setCurrentSentence(sentence);
    } catch (err) {
      console.error('刷新每日英语句子失败:', err);
      setError(languageManager.t('common.loadFailed'));
    } finally {
      setLoading(false);
    }
  };

  // 渲染加载状态
  const renderLoading = () => (
    <div className="daily-english-content__loading">
      <div className="daily-english-content__loading-spinner"></div>
      <div className="daily-english-content__loading-text">{languageManager.t('common.loading')}</div>
    </div>
  );

  // 渲染错误状态
  const renderError = () => (
    <div className="daily-english-content__error">
      <div className="daily-english-content__error-text">{error}</div>
      <button 
        className="daily-english-content__error-retry"
        onClick={handleRefresh}
      >
        {languageManager.t('common.retry')}
      </button>
    </div>
  );

  // 渲染主要内容
  const renderContent = () => {
    if (!currentSentence) return null;

    return (
      <>
        <div 
          className="daily-english-content__area"
          onWheel={(e) => {
            // 阻止滚动事件冒泡到外部
            e.stopPropagation();
          }}
          onTouchMove={(e) => {
            // 阻止触摸滚动事件冒泡到外部
            e.stopPropagation();
          }}
          onScroll={(e) => {
            // 阻止滚动事件冒泡到外部
            e.stopPropagation();
          }}
          onTouchStart={(e) => {
            // 阻止触摸开始事件冒泡
            e.stopPropagation();
          }}
          onTouchEnd={(e) => {
            // 阻止触摸结束事件冒泡
            e.stopPropagation();
          }}
        >
          {/* 英语句子 */}
          <div className="daily-english-content__sentence">
            <div className="daily-english-content__english">
              "{currentSentence.english}"
            </div>
            <div className="daily-english-content__chinese">
              {currentSentence.chinese}
            </div>
          </div>

          {/* 作者信息 */}
          {currentSentence.author && (
            <div className="daily-english-content__author">
              — {currentSentence.author}
            </div>
          )}
        </div>
        
        {/* 刷新按钮 - 固定在右下角，不受滚动影响 */}
        <button 
          className="daily-english-content__refresh"
          onClick={(e) => {
            e.stopPropagation();
            handleRefresh();
          }}
          title={languageManager.t('cards.refreshSentence')}
        >
          {languageManager.t('cards.refresh')}
        </button>
      </>
    );
  };

  return (
    <div 
      className="daily-english-content"
      onClick={(e) => {
        e.stopPropagation();
      }}
      onWheel={(e) => {
        // 阻止滚动事件冒泡到外部
        e.stopPropagation();
      }}
      onTouchMove={(e) => {
        // 阻止触摸滚动事件冒泡到外部
        e.stopPropagation();
      }}
    >
      {loading && renderLoading()}
      {error && renderError()}
      {!loading && !error && renderContent()}
    </div>
  );
};

export default DailyEnglishContent;

